import {
  normaliseCreatinine,
  calculateBmi,
  calculateAdjustedBodyWeight,
  calculateCrClForDisplay,  
} from "./general";

import { calculateIdealBodyWeight } from "./ibw";

const BMI_UNDERWEIGHT = 18.5;
const BMI_OVERWEIGHT = 25;

export function calculateCrc({
  heightCm,
  actualBodyWeightKg,
  age,
  sex,
  serumCreatinine,
  serumCreatinineUnit = "micromoles/L",
}) {
  const height = Number(heightCm);
  const weight = Number(actualBodyWeightKg);
  if (!height || !weight || !age || !sex || !serumCreatinine) return null;
  const serumCrMicromol = normaliseCreatinine(serumCreatinine, serumCreatinineUnit);
  const bmi = calculateBmi({ heightCm: height, actualBodyWeightKg: weight });
  const ibw = calculateIdealBodyWeight({ sex, height });
  const abw = calculateAdjustedBodyWeight({ ibw, actualBodyWeightKg: weight });

  let weightForCrCl;
  let weightTypeForCrCl;
  let bmiCategory;
  if (bmi === null) return null;
  if (bmi < BMI_UNDERWEIGHT) {
    weightForCrCl = weight;
    weightTypeForCrCl = "actual body weight";
    bmiCategory = "underweight";
  } else if (bmi < BMI_OVERWEIGHT) {
    if (!ibw) return null;
    weightForCrCl = ibw;
    weightTypeForCrCl = "ideal body weight";
    bmiCategory = "normal weight";
  } else {
    if (!abw) return null;
    weightForCrCl = abw;
    weightTypeForCrCl = "adjusted body weight";
    bmiCategory = "overweight";
  }

  if (!weightForCrCl) return null;
  const crCl = calculateCrClForDisplay({
    age,
    sex,
    weightKg: weightForCrCl,
    serumCreatinineMicromol: serumCrMicromol,
  });

  return {
    creatinineClearance: crCl,
    weightTypeForCrCl,
    bmi,
    bmiCategory,
  };
}
